import { eventTimeline } from '@/mocks/homeContent';

const statusStyle: Record<string, string> = {
  事件起点: 'bg-accent-100 text-accent-900',
  热度攀升: 'bg-primary-100 text-primary-800',
  讨论分裂: 'bg-secondary-200 text-secondary-900',
  状态标注: 'bg-background-200 text-foreground-700',
};

export default function EventZone() {
  return (
    <section id="事件专区" className="bg-background-100">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid gap-8 lg:grid-cols-[320px_1fr] lg:gap-12">
          {/* intro panel */}
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-900 text-background-50">
                <i className="ri-road-map-line flex h-5 w-5 items-center justify-center" />
              </span>
              <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">事件专区</h2>
            </div>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              不为单个热搜下结论，只把每场争议从「起点、发声、逐帧争议到当前状态」按时间线铺开。谁说了什么、被删了什么、现在标注到哪一步，一目了然。
            </p>
            <div className="mt-6 space-y-3 rounded-xl bg-background-50 p-4 ring-1 ring-background-200">
              {['实锤：至少双信源交叉印证', '存疑：仅单方说法或证据待核', '已辟谣：当事人或权威方澄清'].map((t, i) => (
                <p key={i} className="flex items-start gap-2 text-xs leading-5 text-foreground-600">
                  <span
                    className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${i === 1 ? 'bg-accent-500' : i === 0 ? 'bg-primary-500' : 'bg-secondary-500'}`}
                  />
                  {t}
                </p>
              ))}
              <div className="border-t border-background-200 pt-3">
                <p className="text-xs text-foreground-500">当前专区共收录 <span className="font-bold text-foreground-800">436</span> 场，正在处理 <span className="font-bold text-primary-700">18</span> 场</p>
              </div>
            </div>
          </div>

          {/* timeline */}
          <div className="relative">
            <div className="absolute bottom-4 left-[19px] top-4 w-px bg-gradient-to-b from-primary-300 via-accent-300 to-secondary-200 md:left-[39px]" />
            <div className="space-y-4">
              {eventTimeline.map((e) => (
                <article key={e.date} className="relative flex gap-4 md:gap-6">
                  <span className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-background-50 font-label text-[11px] text-primary-700 ring-2 ring-accent-400 md:h-20 md:w-20 md:flex-col md:rounded-2xl md:justify-center md:ring-1 md:ring-background-200">
                    {e.date.split('.')[0]}
                    <span className="hidden text-[13px] font-black md:block">.{e.date.split('.')[1]}</span>
                  </span>
                  <div className="group flex flex-1 flex-col gap-3 rounded-xl bg-background-50 p-3 ring-1 ring-background-200 transition hover:ring-primary-300 sm:flex-row md:p-4">
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className={`rounded-sm px-2 py-0.5 text-[11px] font-bold ${statusStyle[e.status]}`}>{e.status}</span>
                        <span className="font-label text-xs text-foreground-400">STEP · {e.date}</span>
                      </div>
                      <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">{e.title}</h3>
                      <p className="mt-1.5 text-sm leading-6 text-foreground-600">{e.desc}</p>
                      <a href="#专题话题" className="mt-3 inline-flex items-center gap-1 whitespace-nowrap text-xs font-bold text-primary-600 transition group-hover:gap-2">
                        去专题话题跟进 <i className="ri-arrow-right-line flex h-4 w-4 items-center justify-center" />
                      </a>
                    </div>
                    <div className="relative h-28 w-full shrink-0 overflow-hidden rounded-lg sm:h-24 sm:w-44 md:h-28 md:w-52">
                      <img src={e.img} alt={e.title} title={`事件专区 ${e.title}`} className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105" />
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}